// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__32YL5","boxTitle":"Qualiphy_boxTitle__3arzM","box":"Qualiphy_box__3ZzwT","toggleWrap":"Qualiphy_toggleWrap__28Dfq"};